function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
class AnimateNumber extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      number: 0
    });
    _defineProperty(this, "animate", (number, speed) => {
      this.timer = setInterval(() => {
        if (this.state.number < number) {
          this.setState({
            number: this.state.number + 1
          });
        } else {
          clearInterval(this.timer);
        }
      }, speed);
    });
  }
  componentDidMount() {
    const {
      number,
      speed
    } = this.props;
    number && this.animate(number, speed);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  render() {
    const displayNumber = this.state.number;
    return /*#__PURE__*/React.createElement("span", null, displayNumber);
  }
}
export default AnimateNumber;
AnimateNumber.propTypes = {
  number: PropTypes.number.isRequired,
  speed: PropTypes.number.isRequired
};